module.exports = __webpack_public_path__ + "media/pt_pt_s4_Miciela.100a9842.oga";